<template>
<span>
  <ul v-if="!unit" class="c-changer">
    <li
      v-for="(item, index) in changed"
      :key="index"
      :class="{ 'u-font11': size === 11, 'u-font12': size === 12,'u-font13': size === 13, 'u-font14': size === 14 }"
    >
      {{item}}<span v-if="index !== changed.length-1" :class="{ 'c-changer--m--card': isCard }" class="c-changer--m">m</span>
    </li>
  </ul>
  <span v-else :class="{ 'c-changer--m--card': isCard }" class="c-changer--m" >m</span>
</span>

</template>

<script>
export default {
  name: 'CommonAreaChanger',
  props: [
    'val',
    'size',
    'unit',
    'isCard',
  ],
  data() {
    return {};
  },
  computed: {
    changed() {
      const ret = this.val.toString().split('m2');
      return ret;
    },
  },
};
</script>

<style lang='scss' scoped>
@charset 'UTF-8';
.c-changer {
  display:inline-flex;
  flex-wrap: wrap;
  li {
    list-style: none;
  }
  li:nth-child(n+2) {
    margin-left: 5px;
  }
  &--m {
    position: relative;
    &:after {
      content: '2';
      font-size: 10px;
      position: absolute;
    }
    &--card {
      &:after {
        top: -6px;
      }
    }
  }
}
.u-font11 { font-size:11px !important}
.u-font12 { font-size:12px !important}
.u-font13 { font-size:13px !important}
.u-font14 { font-size:14px !important}
</style>
